<template>
  <div class="base-layout" ref="$layout" @click="onClickUpdateLogin">
    <!-- <TheHeader></TheHeader> -->
    <Header></Header>
    <main class="d-flex flex-column">
      <router-view></router-view>
    </main>
    <TheFooter></TheFooter>
    <BaseModal
      name="logoutTimeModal"
      width="420"
      :clickToClose="true"
      @before-close="timeoutSeconds = 60"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="!tw-rounded-[10px] !tw-shadow-none"
      @closed="logoutTimeModalClosed"
    >
      <div class="tw-p-[30px]">
        <div class="tw-flex tw-justify-end">
          <button
            type="button"
            class="btn-close !tw-shadow-none"
            @click="$modal.hide('logoutTimeModal')"
          ></button>
        </div>
        <div class="tw-py-[16px]">
          <p
            class="tw-text-center tw-text-[18px] tw-mb-[15px] tw-text-[#213960]"
          >
            Выйти из Сириус?
          </p>
          <p class="tw-text-[14px] tw-text-[#5A697F]">
            Кажется сейчас вы ничего не делаете, поэтому скоро мы вернем вас на
            страницу входа. Это нужно, чтобы вашим аккаунтом не могли
            воспользоваться, когда вы отлучаетесь.
          </p>
          <p
            class="tw-text-[#213960] tw-text-center tw-text-[18px] tw-mb-[15px]"
          >
            До выхода осталось 00:{{ timeoutSeconds }}
          </p>
          <div class="tw-grid tw-grid-cols-2 tw-gap-[10px] tw-justify-center">
            <button class="tw-app-btn-auth-outline" @click="onLogout">
              Выйти
            </button>
            <button class="tw-app-btn-auth" @click="toBeThePage">
              Остаться
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <B2BOrderModal />

    <ModalVideoSupport />
    <div
      class="auth-layout-fallback tw-bg-main tw-justify-center tw-items-center tw-text-center tw-text-[#6C88B4]"
    >
      <div class="tw-overflow-y-scroll tw-w-full tw-py-[40px]">
        <img
          class="tw-w-[200px] tw-mb-[15px]"
          :src="require(`@/assets/images/logo-white.svg`)"
        />

        <div class="tw-text-[12px] tw-px-[20px]">
          Платформа контроля транспорта<br />
          и управления арендой
        </div>

        <img
          class="tw-w-full tw-max-w-[500px] tw-my-[40px]"
          :src="require(`@/assets/images/login-bg.png`)"
        />

        <div class="tw-text-[15px] tw-px-[20px]">
          Рекомендуемый размер браузера для<br />
          корректной работы 1280×800.<br />
          Используйте планшет от 12 дюймов<br />
          горизонтально или ПК<br />
          <div class="tw-mt-[10px]">
            Кроме того, можно уменьшить масштаб<br />
            страницы в браузере, чтобы интерфейс<br />
            полностью помещался на экране вашего устройства.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tooltip } from "bootstrap";
// import TheHeader from '@/components/TheHeader.vue'
import Header from "@/components/Header.vue";
import TheFooter from "@/components/TheFooter.vue";

import ModalVideoSupport from "@/components/ui/ModalVideoSupport.vue";
import B2BOrderModal from "@/components/B2BOrderModal.vue";
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  components: {
    // TheHeader,
    Header,
    TheFooter,
    ModalVideoSupport,
    B2BOrderModal,
  },

  props: {},
  data() {
    return {
      timeToLogOut: 3540000,
      // timeToLogOut: 10000,
      timeoutForLogout: null,
      timeoutInterval: null,
      timeoutSeconds: 60,
      openedForm: false,
    };
  },
  methods: {
    logoutTimeModalClosed() {
      this.onClickUpdateLogin();
      this.timeoutSeconds = 60;
      this.$modal.hide("logoutTimeModal");
    },
    toBeThePage() {
      console.log("hat token: " + !!localStorage.getItem("user-token"));
      if (!localStorage.getItem("user-token")) {
        //проверим, если токена по какой то причине уже нет, разлогин
        this.onLogout();
      }
      this.$modal.hide("logoutTimeModal");
    },
    onLogout() {
      clearTimeout(this.timeoutForLogout);
      clearInterval(this.timeoutInterval);
      this.$modal.hide("logoutTimeModal");
      localStorage.removeItem("user-token");
      localStorage.removeItem("loginAt");
      localStorage.removeItem("translations");
      this.$router.push("/auth");
    },
    onClickUpdateLogin() {
      let newTime = new Date();
      localStorage.setItem("loginAt", newTime);
      this.timeoutSeconds = 60;
    },
    checkTime(e) {
      let newTime = Date.parse(localStorage.getItem("loginAt"));
      let currentTime = new Date();
      if (currentTime - newTime >= this.timeToLogOut) {
        this.onLogout();
      }
    },
    ...mapActions("translationModule", ["getTranslation"]),
  },
  created() {
    this.getTranslation(1);
    this.checkTime();
  },
  mounted() {
    window.addEventListener("focus", this.checkTime);
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl);
    });
    this.timeoutInterval = setInterval(() => {
      let newTime = Date.parse(localStorage.getItem("loginAt"));
      let currentTime = new Date();
      if (currentTime - newTime >= this.timeToLogOut) {
        if (!this.openedForm) {
          this.$modal.show("logoutTimeModal");
        }
        this.timeoutSeconds--;
        if (this.timeoutSeconds == 0) {
          this.onLogout();
        }
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timeoutInterval);
    window.removeEventListener("focus", this.checkTime);
  },
};
</script>

<style lang="scss">
.auth-layout-fallback {
  width: 100vw;
  height: 100vh;
  background-color: white;
  padding-bottom: 0;
  display: none;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 50;

  &__logo-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 40px;
    flex-grow: 1;
  }

  &__logo {
    width: 260px;
  }

  &__mincifri {
    width: 156px;
  }

  &__bottom {
    background-color: #0c63aa;
    font-size: 14px;
    padding: 25.5px 15px;
    text-align: center;
    color: white;
  }
}
@media (max-width: 1000px) {
  .auth-layout-fallback {
    display: flex;
  }
}
</style>
